import * as types from '../mutation-types';
import router from '../../router';

const USER_INFO = localStorage.getItem('userInfo');
const state = () => ({
    userInfo: USER_INFO ? JSON.parse(USER_INFO) : {}
});

// getters
const getters = {};

// actions
const actions = {
    login({ commit }, payload) {
        commit(types.LOGIN, payload);
    },
    logout({ commit }, payload) {
        commit(types.LOGOUT, payload);
    },
    updateUserInfo({ commit }, payload) {
        commit(types.UPDATE_USER_INFO, payload);
    }
};

// mutations
const mutations = {
    [types.LOGIN](state, { userInfo, token }) {
        localStorage.setItem('userInfo', JSON.stringify(userInfo));
        localStorage.setItem('auth-token', token);
        state.userInfo = userInfo;
    },
    [types.LOGOUT](state, payload = {}) {
        localStorage.clear();
        sessionStorage.clear();
        state.userInfo = {};
        router.push({
            path: '/login',
            query: {
                redirect: payload.redirect
            }
        });
    },
    [types.UPDATE_USER_INFO](state, { userInfo }) {
        const newUserInfo = {
            ...state.userInfo,
            ...userInfo
        };
        localStorage.setItem('userInfo', JSON.stringify(newUserInfo));
        state.userInfo = newUserInfo;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
